import axios from '../axios'

const getListEventsApi = async (startTime, endTime) => {
  return await axios.get('api/student/events', {
    params: { startTime, endTime },
  })
}

export default getListEventsApi
